<template>
  <ul
    class="main-menu__sublist"
    data-test-id="submenu-list"
    @mouseenter="$emit('tooltipHide')"
  >
    <li
      class="main-menu__subitem"
      v-for="(item, index) in submenuList"
      :key="index"
      v-if="item.visibilityRules"
      data-test-id="submenu-list-item"
    >
      <router-link
        :to="item.routerLink"
        class="main-menu__subitem-link"
        data-test-id="submenu-list-item-link"
      >
        <md-icon
          data-test-id="submenu-list-item-icon"
          :md-src="item.icon.includes('.svg') ? item.icon : null"
        >
          {{ !item.icon.includes('.svg') && item.icon }}
        </md-icon>
        <span
          class="main-menu__subitem-text"
          data-test-id="submenu-list-item-text"
        >
          {{ item.label }}
        </span>
      </router-link>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'submenu-list',

    props: {
      submenuList: { type: Array, required: false }
    },

    data () {
      return {}
    },
    methods: { }
  }
</script>

<style scoped lang="scss">
  @import "~scss/variables";
  @import "~scss/mixins";

  .main-menu__sublist {
    position: absolute;
    list-style: none;
    background-color: #fff;
    color: $col-text;
    top: 0;
    left: calc(100% + 20px);
    border-radius: 16px;
    padding: 10px;
    min-width: 140px;
    width: max-content;
    box-shadow: 4px 4px 4px 0 rgba(134, 134, 134, 0.2);
    font-size: $font-size-l;

    .main-menu__subitem {
      padding: 0px;
      border-radius: 10px;
      display: flex;
      gap: 10px;
      align-items: center;
      transition: all .3s cubic-bezier(.4, 0, .2, 1);
      margin-bottom: 5px;

      &-link {
        text-decoration: none;
        color: $col-text;
        display: flex;
        gap: 10px;
        align-items: center;
        width: 100%;
        padding: 10px;
      }

      .md-icon {
        color: $col-text;
        margin: 0px;

        /deep/ path,
        /deep/ rect,
        /deep/ svg {
          color: $col-text;
          fill :$col-text;
          transition: .1s;
        }
      }

      &-text {
        @include font('main', $font-size-l, 600);

        @include respond-to(medium) {
          @include font('main', $font-size-m, 600);
        }
      }

      &:hover,
      &:has(.router-link-active) {
        background-color: $color-graphite;

        .md-icon {
          color: $color-mint;

          /deep/ path,
          /deep/ rect,
          /deep/ svg {
            color: $color-mint;
            fill: $color-mint;
          }
        }

        .main-menu__subitem-link {
          color: $color-mint !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/navigation/mainMenu/submenuList.vue